// Build edition, set by tools/build.mjs from VERO_EDITION:
//   standard — hosted web app / PWA / Windows and macOS installers
//   personal — the single-file offline package (tools/build-personal.mjs)
//   store    — builds for the Apple App Store and Google Play (docs/17_APPS_AND_DISTRIBUTION.md)
//   preview  — the in-memory demo page
declare const __VERO_EDITION__: string | undefined;
declare const __VERO_BUILD__: string | undefined;
export const EDITION: string = typeof __VERO_EDITION__ !== 'undefined' ? __VERO_EDITION__ : 'standard';

/**
 * Whether the app may show anything that leads to buying: plan prices and "choose plan", the payment portal, "manage
 * your plan on the website", and licence-code redemption. Store builds never do (App Store Review Guidelines 3.1.1 /
 * 3.1.3, Google Play Payments policy §4): there the app is a client for an account the advisor already has, and
 * subscriptions are handled outside the app. Everything else — the CRM, sign-in, invitations, account deletion,
 * subscription status — is identical in every edition.
 */
export const PURCHASE_UI: boolean = EDITION !== 'store';

/** when this copy of the app was built (Cyprus time), shown in Settings so a device's version can be told at a glance */
export const BUILD_STAMP: string = typeof __VERO_BUILD__ === 'string' ? __VERO_BUILD__ : '';
